var map = {
	"./cnn-money-x2.png": 2043,
	"./cnn-money.png": 2248,
	"./economist-x2.png": 2044,
	"./economist.png": 2249,
	"./mashable-x2.png": 2045,
	"./mashable.png": 2250,
	"./tech-crunch-x2.png": 2046,
	"./tech-crunch.png": 2251,
	"./thenewyorker-x2.png": 2047,
	"./thenewyorker.png": 2252,
	"./thrillist-x2.png": 2048,
	"./thrillist.png": 2253,
	"./time-x2.png": 2049,
	"./time.png": 2254,
	"./usa-today-x2.png": 2050,
	"./usa-today.png": 2255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2247;